import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 md:py-18 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold">常见问题</h2>
          <p className="text-sm text-foreground-500 mt-1.5">关于茄子视频，你想知道的都在这里</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 md:px-6 md:py-4.5 text-left cursor-pointer hover:bg-background-50 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{item.question}</span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${
                  openIndex === index
                    ? 'bg-primary-500 text-white rotate-45'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-48 pb-4 md:pb-5' : 'max-h-0'
                }`}
              >
                <p className="px-5 md:px-6 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}